export const LAYER_TYPES = {
    BUILDINGS_LAYER: 0,
    TIERS_LAYER: 1,
    APARTMENTS_LAYER: 2,
  };